import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, getToken } from "../lib/api";
import { useAuth } from "./AuthContext";

const CartCtx = createContext(null);

export const useCart = () => useContext(CartCtx);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  const refreshCart = useCallback(() => {
    if (!getToken()) {
      setCount(0);
      return;
    }
    api("/cart", { auth: true })
      .then((c) => setCount(c.count || 0))
      .catch(() => {});
  }, []);

  useEffect(() => {
    refreshCart();
  }, [user?.id, refreshCart]);

  return <CartCtx.Provider value={{ count, refreshCart }}>{children}</CartCtx.Provider>;
}
